import { useEffect, useState } from 'react';

/**
 * Ticks every second while the run is active (non-terminal status).
 */
export function usePipelineClock(isLive: boolean): Date {
	const [nowMs, setNowMs] = useState(() => Date.now());

	useEffect(() => {
		if (!isLive) return;

		const intervalId = window.setInterval(() => {
			setNowMs(Date.now());
		}, 1000);

		return () => window.clearInterval(intervalId);
	}, [isLive]);

	return new Date(nowMs);
}
